import React from 'react';
import ExpertiseSection from '../../components/ExpertiseSection/ExpertiseSection';
// import webExpertiseResponsive from '../../assets/web_development/web-expertise-responsive-design.webp';
// import webExpertiseUX from '../../assets/web_development/web-expertise-ux-design.png';
import WebExpertiseResponsiveDesign from '../../assets/web_development/responsive-design.webp'; // Import your background image here
import WebExpertiseUserExperience from '../../assets/web_development/user-experience.webp'; // Import your background image here
import webExpertiseBackend from '../../assets/web_development/backend-development.webp';
import webExpertiseData from '../../assets/web_development/datenbank-management.webp';
const expertiseData = [
{
    id: 1,
    title: 'Responsive Design',
    description: 'Wir sorgen dafür, dass Ihre Website auf jedem Gerät perfekt aussieht – egal ob Smartphone, Tablet oder Desktop. Mit flexiblen Layouts und mobilen Optimierungen stellen wir sicher, dass Ihre Inhalte überall gut ankommen. Natürlich inklusive schneller Ladezeiten und umfassender Browser-Kompatibilität.',
    image: WebExpertiseResponsiveDesign,
    },
    {
    id: 2,
    title: 'User Experience (UX)',
    description: 'Wir gestalten Ihre Website so, dass sich Nutzer sofort zurechtfinden – mit durchdachten Abläufen, klaren Strukturen und kleinen Details, die den Unterschied machen. Dabei achten wir besonders auf Zugänglichkeit und messbare Nutzerzufriedenheit.',
    image: WebExpertiseUserExperience,
    },
    {
    id: 3,
    title: 'Backend-Entwicklung',
    description: 'Im Hintergrund sorgt eine moderne, leistungsstarke Technik dafür, dass Ihre Website zuverlässig läuft – selbst bei vielen Besuchern. Wir kümmern uns um schnelle Ladezeiten, sichere Datenübertragung und eine nahtlose Verbindung zwischen Frontend und Server.',
    image: webExpertiseBackend,
    },
    {
    id: 4,
    title: 'Datenbankmanagement',
    description: 'Ihre Daten sind bei uns in besten Händen. Wir sorgen für strukturierte, sichere und schnell erreichbare Daten – ob Produktkataloge, Nutzerkonten oder Bestellungen. Gleichzeitig setzen wir auf Datenschutz und zukunftsfähige Technologien.',
    image: webExpertiseData,
    }
];

function WebExpertise() {
  return (
    <div className="web-expertise">
      <ExpertiseSection
        headerTitle="Web Entwicklung Expertise"
        headerSubtitle="Technologische Exzellenz für digitale Spitzenlösungen"
        items={expertiseData}
        theme="web-development"
      />
    </div>
  );
}

export default WebExpertise;